import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { getCacheData } from "../../services/CacheService";
import { getSolucionLimpieza, saveSolucionLimpieza } from "../../services/SolucionLimpiezaService";
import { deleteFileBucket, getFileByUrl } from "../../services/BucketBackService";
import Message from "../../utils/Message";
import SolucionLimpiezaMaterialLCDialog from "./SolucionLimpiezaMaterialLCDialog";
import CodigoExternoDialog from "../dialogs/CodigoExternoDialog";
import FotoDialog from "../dialogs/FotoDialog";
import WaitingDialog from "../../utils/WaitingDialog";
import { generaCodigo } from "../../utils/utils";

const initialState = {
  id: null,
  codigo: "",
  descripcion: "SOLUCION PARA LENTE DE CONTACTO",
  idSlMarca: null,
  idSlIndicacion: null,
  idSlPresentacion: null,
  idSlLaboratorio: null,
  ubicacion: "",
  existenciaMinima: 0,
  puntoPedido: 0,
  existenciaMaxima: 0,
  idLcMaterial: null,
  codigoExterno: "",
  observaciones: "",
};

const nameItemsText = "Solución de Limpieza";
//
// #############################################################################
//
const SolucionLimpieza = () => {
  const params = useParams();
  const _idArticulo = params.idArticulo;
  const _action = params.action;
  const navigate = useNavigate();
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openSolucionLimpiezaMaterialLCDialog, setOpenSolucionLimpiezaMaterialLCDialog] = useState(false);
  const [openCodigoExternoDialog, setOpenCodigoExternoDialog] = useState(false);
  const [openFotoDialog, setOpenFotoDialog] = useState(false);
  const [lcMaterialList, setLcMaterialList] = useState([]);
  const [codigoExternoList, setCodigoExternoList] = useState([]);
  const [fotoList, setFotoList] = useState([]);
  const [actionCrud, setActionCrud] = useState("");
  const [itemCrud, setItemCrud] = useState(initialState);
  const [arrayFotos, setArrayFotos] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState({});
  const [slMarcas, setSlMarcas] = useState([])
  const [slIndicaciones, setSlIndicaciones] = useState([])
  const [slPresentaciones, setSlPresentaciones] = useState([])
  const [slLaboratorios, setSlLaboratorios] = useState([])
  const [titleComponent, setTitleComponent] = useState("");
  const [valueACSlMarca, setValueACSlMarca] = useState(null);
  const [inputvalueACSlMarca, setInputValueACSlMarca] = useState("");
  const [valueACSlIndicacion, setValueACSlIndicacion] = useState(null);
  const [inputvalueACSlIndicacion, setInputValueACSlIndicacion] = useState("");
  const [valueACSlPresentacion, setValueACSlPresentacion] = useState(null);
  const [inputValueACSlPresentacion, setInputValueACSlPresentacion] = useState("");
  const [valueACSlLaboratorio, setValueACSlLaboratorio] = useState(null);
  const [inputValueACSlLaboratorio, setInputValueACSlLaboratorio] = useState("");

  const tableColumnsLcMaterialList = [
    {
      field: "descripcion_lc_material",
      headerName: "Material de Lente de Contacto",
      headerAlign: "center",
      align: "left",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_material;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 120,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          {(_action === "new" || _action === "update") && (
            <>
              <Tooltip title="quitar material">
                <span>
                  <IconButton
                    size="small"
                    aria-label="delete"
                    onClick={() =>
                      handleClickLcMaterial(params.row, "delete")
                    }
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];

  const tableColumnsCodigoExternoList = [
    {
      field: "descripcion_proveedor",
      headerName: "Proveedor",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.descripcion_proveedor}</span>
      ),
    },
    {
      field: "codigo_externo",
      headerName: "Código Externo",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.codigo_externo}</span>
      ),
    },
    ...(_action !== "disable" && (actionCrud === "new" || actionCrud === "update") ? [{
      field: "actions",
      headerName: "Acciones",
      width: 150,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <Tooltip title="Editar Código Externo">
            <IconButton
              size="small"
              aria-label="edit"
              onClick={() => handleClickCodigoExterno(params.row, "update")}
            >
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Quitar Código Externo">
            <IconButton
              size="small"
              aria-label="delete"
              onClick={() => handleClickCodigoExterno(params.row, "delete")}
            >
              <RemoveCircleOutlineIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    }] : []),
  ];

  const tableColumnsFotoList = [
    {
      field: "preview",
      headerName: "Vista Previa",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        const archivo = params.row.archivo;
        let id_s3 = params.row.id_s3;
        let urlImg = getFileByUrl(id_s3);
        if (archivo !== undefined) {
          if (archivo.type.startsWith("image/")) {
            return (
              <img
                src={URL.createObjectURL(archivo)}
                alt="preview"
                style={{
                  width: 70,
                  height: 70,
                  objectFit: "cover",
                  borderRadius: "5px",
                  display: "block"
                }}
              />
            );
          } else {
            return <span>No disponible</span>;
          }
        } else {
          return (
            <img
              src={urlImg}
              alt="preview"
              style={{
                width: 70,
                height: 70,
                objectFit: "cover",
                borderRadius: "5px",
                display: "block"
              }}
            />
          );
        }
      },
    },
    ...(_action !== "disable" && (actionCrud === "new" || actionCrud === "update") ? [{
      field: "actions",
      headerName: "Acciones",
      width: 120,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title="Quitar Foto">
          <IconButton
            size="small"
            aria-label="delete"
            onClick={() => handleClickFoto(params.row, "delete")}
          >
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      ),
    }] : []),
  ];

  const tableOptionsLcMaterialList = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id ?? row.id_lc_material,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };

  const tableOptionsCodigoExternoList = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id || row.id_proveedor,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };

  const tableOptionsFotoList = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id || row.id_s3,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
        display: 'flex',
        alignItems: "center",
        padding: '8px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
      '& .MuiDataGrid-row': {
        minHeight: '120px !important',
        maxHeight: '120px !important',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      },
      '& .MuiDataGrid-cell[data-field="preview"]': {
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
        padding: '4px',
        overflow: 'hidden',
      },
    },
  };
  //
  // ##########################################################################
  //
  useEffect(() => {
    loadSlMarcas();
    loadSlIndicaciones();
    loadSlPresentaciones();
    loadSlLaboratorios();

    if (_action === "new") {
      setTitleComponent("Nueva " + nameItemsText);
      setItemCrudLocal({
        ...itemCrudLocal,
        codigo: generaCodigo(),
      });
    } else {
      load();
      setActionCrud(_action);

    }
  }, []);
  //
  // ################################################################################
  //
  const loadSlMarcas = async () => {
    const response = await getCacheData("sl_marca");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setSlMarcas(_var);
    } else {
      setSlMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadSlIndicaciones = async () => {
    const response = await getCacheData("sl_indicacion")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setSlIndicaciones(_var);
    } else {
      setSlIndicaciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadSlPresentaciones = async () => {
    const response = await getCacheData("sl_presentacion")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setSlPresentaciones(_var);
    } else {
      setSlPresentaciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadSlLaboratorios = async () => {
    const response = await getCacheData("sl_laboratorio");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setSlLaboratorios(_var);
    } else {
      setSlLaboratorios([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/articulo/solucion-limpieza-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleClickLcMaterial = (parItemCrud, parActionCrud) => {
    let _itemCrud = {}

    if (parActionCrud === "new") {
      setOpenSolucionLimpiezaMaterialLCDialog(true);
    } else {
      // delete lc material

      const _updatedList = lcMaterialList.filter(
        (item) => item.id_lc_material !== parItemCrud.id_lc_material
      );
      setLcMaterialList(_updatedList);
      return;
    }
  };
  //
  // ##########################################################################
  //
  const handleClickCodigoExterno = (itemCrud, action) => {
    let _itemCrud = {}

    if (action === "delete") {
      const updatedList = codigoExternoList.filter(
        (item) => item.id_proveedor !== itemCrud.id_proveedor
      );
      setCodigoExternoList(updatedList);
      return;
    }

    if (action === "update") {
      _itemCrud = {
        id: itemCrud.id ? itemCrud.id : uuid(),
        id_proveedor: itemCrud.id_proveedor,
        descripcion_proveedor: itemCrud.descripcion_proveedor,
        codigo_externo: itemCrud.codigo_externo,
      }
      setItemCrud(_itemCrud);
      setActionCrud(action);
      setOpenCodigoExternoDialog(true);
    } else {
      setActionCrud(action);
      setItemCrud(itemCrud);
      setOpenCodigoExternoDialog(true);
    }
  };
  //
  // ##########################################################################
  //
  const handleClickFoto = (itemCrud, action) => {
    if (action === "delete") {
      const updatedList = fotoList.filter(
        (item) => item.id_s3 !== itemCrud.id_s3
      );
      deleteFileBucket(itemCrud.id_s3);
      setFotoList(updatedList);
      return;
    }
    setActionCrud(action);
    setOpenFotoDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleSave = async () => {

    if (itemCrudLocal.descripcion === "") {
      setMessage({
        messageText: "Debes ingresar alguna Descripción",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACSlMarca) {
      setMessage({
        messageText: "Debes seleccionar la Marca",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACSlIndicacion) {
      setMessage({
        messageText: "Debes seleccionar la Indicación",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACSlPresentacion) {
      setMessage({
        messageText: "Debes seleccionar la Presentación",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACSlLaboratorio) {
      setMessage({
        messageText: "Debes seleccionar el Laboratorio",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    const _existenciaMinima = Math.max(0, +itemCrudLocal.existenciaMinima);
    const _puntoPedido = Math.max(0, +itemCrudLocal.puntoPedido);
    const _existenciaMaxima = Math.max(0, +itemCrudLocal.existenciaMaxima);

    if (_existenciaMinima > _puntoPedido || _puntoPedido > _existenciaMaxima) {
      setMessage({
        messageText: "Los valores de Existencia Mínima, Punto de Pedido y Existencia Máxima no son válidos",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (lcMaterialList.length === 0) {
      setMessage({
        messageText: "Debes seleccionar al menos un Material de Lente de Contacto",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    let object = {};

    if (_action === "update") {
      object.id = itemCrudLocal.id;
    }

    object = {
      ...itemCrudLocal,
      codigo: itemCrudLocal.codigo,
      descripcion: itemCrudLocal.descripcion,
      idSlMarca: valueACSlMarca.id,
      idSlIndicacion: valueACSlIndicacion.id,
      idSlPresentacion: valueACSlPresentacion.id,
      idSlLaboratorio: valueACSlLaboratorio.id,
      ubicacion: itemCrudLocal.ubicacion.toUpperCase(),
      existenciaMinima: _existenciaMinima,
      puntoPedido: _puntoPedido,
      existenciaMaxima: _existenciaMaxima,
      lsMaterialList: lcMaterialList ? lcMaterialList : [],
      lsCodigoExternoList: codigoExternoList ? codigoExternoList : [],
      lsFotoList: fotoList ? fotoList : [],
      observaciones: itemCrudLocal.observaciones.toUpperCase(),
    }

    setIsDoingSomething(true);
    const response = await saveSolucionLimpieza(_action, object);
    setIsDoingSomething(false);

    if (response.ok) {
      setTimeout(() => {
        navigate("/articulo/solucion-limpieza-table");
      }, 500);
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getSolucionLimpieza({ id: _idArticulo });
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      if (_action === "update") {
        setTitleComponent("Editando " + nameItemsText + ' ' + _response.codigo);
      } else if (_action === "disable") {
        setTitleComponent("Deshabilitando " + nameItemsText + ' ' + _response.codigo);
      } else if (_action === "enable") {
        setTitleComponent("Habilitando " + nameItemsText + ' ' + _response.codigo);
      }

      let _lcMaterialList = _response.material_lc_list.map((item) => {
        return {
          id: item.id,
          id_lc_material: item.id_lc_material,
          descripcion_lc_material: item.descripcion_lc_material,
        }
      });
      setLcMaterialList(_lcMaterialList);

      let _codigoExternoList = _response.codigo_externo_list.map((item) => {
        return {
          id: item.id,
          id_proveedor: item.id_proveedor,
          descripcion_proveedor: item.descripcion_proveedor + (item.contacto_proveedor ? " - " + item.contacto_proveedor : ""),
          codigo_externo: item.codigo_externo,
        }
      });
      setCodigoExternoList(_codigoExternoList);

      let _fotoList = _response.foto_list.map((item) => {
        return {
          id: item.id,
          id_s3: item.id_s3

        }
      });
      setFotoList(_fotoList);

      setItemCrudLocal({
        ...itemCrudLocal,
        id: _response.id,
        codigo: _response.codigo,
        descripcion: _response.descripcion,
        ubicacion: _response.ubicacion,
        existenciaMinima: _response.existencia_minima,
        puntoPedido: _response.punto_pedido,
        existenciaMaxima: _response.existencia_maxima,
        observaciones: _response.observaciones,
      });
      setValueACSlMarca({
        id: _response.id_sl_marca,
        label: _response.descripcion_sl_marca,
      });
      setValueACSlIndicacion({
        id: _response.id_sl_indicacion,
        label: _response.descripcion_sl_indicacion,
      });
      setValueACSlPresentacion({
        id: _response.id_sl_presentacion,
        label: _response.descripcion_sl_presentacion,
      });
      setValueACSlLaboratorio({
        id: _response.id_sl_laboratorio,
        label: _response.descripcion_sl_laboratorio,
      });
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const handleCloseLcMaterialDialog = () => {
    setOpenSolucionLimpiezaMaterialLCDialog(false);
  }
  //
  // ################################################################################
  //
  const handleCloseCodigoExternoDialog = () => {
    setOpenCodigoExternoDialog(false);
  }
  //
  // ################################################################################
  //
  const handleCloseFotoDialog = () => {
    setOpenFotoDialog(false);
  }
  //
  // ################################################################################ 
  //
  const handleOnSaveLcMaterial = (parItemCrud) => {
    let _lcMaterialList = [...lcMaterialList];

    let _existe = false

    _lcMaterialList.forEach((item) => {
      if (item.id === parItemCrud.id_lc_material) {
        _existe = true;
      }
    });

    if (_existe) {
      setMessage({
        messageText: "Ya ha sido ingresado este Material",
        severity: "error",
      });
      setShowMessage(true);
      return false;
    }

    _lcMaterialList.push(parItemCrud);
    setLcMaterialList(_lcMaterialList);
    return true;
  }
  //
  // ################################################################################
  //
  const handleOnSaveCodigoExterno = (parItemCrud, parAction) => {
    let _codigoExternoList = [...codigoExternoList];
    if (parAction !== "delete") {
      let _existe = false
      _codigoExternoList.forEach((item) => {
        if (item.id_proveedor === parItemCrud.id_proveedor) {
          if (item.id !== parItemCrud.id) {
            _existe = true;
          }
        }
      });
      if (_existe) {
        setMessage({
          messageText: "Ya ha sido ingresado un Código Externo para el Proveedor seleccionado",
          severity: "error",
        });
        setShowMessage(true);
        return false;
      }
      if (parAction === "new") {
        _codigoExternoList.push(parItemCrud)
        setCodigoExternoList(_codigoExternoList);
        return true;
      } else {
        const indexToUpdate = _codigoExternoList.findIndex((item) =>
          item.id_proveedor === parItemCrud.id_proveedor);
        if (indexToUpdate !== -1) {
          _codigoExternoList.splice(indexToUpdate, 1);
        }
        _codigoExternoList.push(parItemCrud)
        setCodigoExternoList(_codigoExternoList);
        setOpenCodigoExternoDialog(false);
        return true;
      }
    } else {
      const indexToDelete = _codigoExternoList.findIndex((item) =>
        item.id_proveedor === parItemCrud.id_proveedor);
      if (indexToDelete !== -1) {
        _codigoExternoList.splice(indexToDelete, 1);
        setCodigoExternoList(_codigoExternoList);
      }
    }
  }
  //
  // ################################################################################
  //
  const handleOnSaveFoto = (items) => {
    // busco dentro de fotoList si existe el id_s3
    let _varList = fotoList;
    let _existe = false;
    _varList.forEach((itemList) => {
      items.forEach((item) => {
        if (itemList.nombre === item.nombre) {
          _existe = true;
        }
      }
      );
    });
    if (_existe) {
      setMessage({
        messageText: "Al menos una de las fotos ya se encuentra en la lista",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }
    setFotoList(
      fotoList.concat(items)
    );
    setOpenFotoDialog(false);
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {titleComponent}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo"
                  label="Código"
                  variant="outlined"
                  size="small"
                  name="codigo"
                  value={itemCrudLocal.codigo}
                  onChange={handleChange}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcion"
                  label="Descripción"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={itemCrudLocal.descripcion ? itemCrudLocal.descripcion : ""}
                  onChange={handleChange}
                  // disabled={actionCrud === "disable" || actionCrud === "enable"}
                  disabled={true}
                />
              </Grid>

            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  sx={{ width: "100%", pb: 1 }}
                  id="id-marca"
                  size="small"
                  value={
                    valueACSlMarca && valueACSlMarca.id
                      ? valueACSlMarca
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACSlMarca(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idSlMarca: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputvalueACSlMarca}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACSlMarca(newInputValue);
                  }}
                  options={slMarcas}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Marca"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadSlMarcas();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  sx={{ width: "100%", pb: 1 }}
                  id="id-indicacion"
                  size="small"
                  value={
                    valueACSlIndicacion && valueACSlIndicacion.id
                      ? valueACSlIndicacion
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACSlIndicacion(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idSlIndicacion: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputvalueACSlIndicacion}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACSlIndicacion(newInputValue);
                  }}
                  options={slIndicaciones}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Indicación"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadSlIndicaciones();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  sx={{ width: "100%", pb: 1 }}
                  id="id-presentacion"
                  size="small"
                  value={
                    valueACSlPresentacion && valueACSlPresentacion.id
                      ? valueACSlPresentacion
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACSlPresentacion(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idSlPresentacion: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACSlPresentacion}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACSlPresentacion(newInputValue);
                  }}
                  options={slPresentaciones}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Presentación"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadSlPresentaciones();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  sx={{ width: "100%", pb: 1 }}
                  id="id-laboratorio"
                  size="small"
                  value={
                    valueACSlLaboratorio && valueACSlLaboratorio.id
                      ? valueACSlLaboratorio
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACSlLaboratorio(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idSlLaboratorio: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACSlLaboratorio}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACSlLaboratorio(newInputValue);
                  }}
                  options={slLaboratorios}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Laboratorio"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadSlLaboratorios();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={5}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="ubicacion"
                  label="Ubicación"
                  variant="outlined"
                  size="small"
                  name="ubicacion"
                  value={itemCrudLocal.ubicacion}
                  onChange={handleChange}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <TextField
                  type="number"
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    min: 0,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  id="existenciaMinima"
                  label="Existencia Mínima"
                  variant="outlined"
                  size="small"
                  name="existenciaMinima"
                  value={itemCrudLocal.existenciaMinima}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <TextField
                  type="number"
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    min: 0,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  id="puntoPedido"
                  label="Punto de Pedido"
                  variant="outlined"
                  size="small"
                  name="puntoPedido"
                  value={itemCrudLocal.puntoPedido}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <TextField
                  type="number"
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    min: 0,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  id="existenciaMaxima"
                  label="Existencia Máxima"
                  variant="outlined"
                  size="small"
                  name="existenciaMaxima"
                  value={itemCrudLocal.existenciaMaxima}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                m: 1,
                mx: 5,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title="Ingresar Material de Lente de Contacto">
                      <Button
                        className="btn-add-custom"
                        variant="contained"
                        onClick={() => handleClickLcMaterial({}, "new")}
                        size="small"
                        sx={{ mb: 1, pb: 1, mt: 1 }}
                      >
                        Material de Lente de Contacto
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <DataGrid
                    rows={lcMaterialList}
                    columns={tableColumnsLcMaterialList}
                    {...tableOptionsLcMaterialList}
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                mx: 5,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title="Ingresar Código Externo">
                      <Button
                        className="btn-add-custom"
                        variant="contained"
                        onClick={() => handleClickCodigoExterno({}, "new")}
                        size="small"
                        sx={{ mb: 1, pb: 1, mt: 1 }}
                      >
                        Código externo
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <DataGrid
                    rows={codigoExternoList}
                    columns={tableColumnsCodigoExternoList}
                    {...tableOptionsCodigoExternoList}
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                mx: 5,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title={fotoList.length >= 10 ? "Máximo de 10 fotos alcanzado" : "Ingresar Foto"}>
                      <Button
                        className="btn-add-custom"
                        variant="contained"
                        onClick={() => handleClickFoto({}, "new")}
                        size="small"
                        sx={{ mb: 1, pb: 1, mt: 1 }}
                        disabled={fotoList.length >= 10}
                      >
                        Foto ({fotoList.length}/10)
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <Box sx={{
                    maxHeight: "380px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    margin: "center",
                    marginTop: "10px",
                    marginBottom: "5px",
                    position: "relative"
                  }}>
                    <DataGrid
                      rows={fotoList}
                      columns={tableColumnsFotoList}
                      {...tableOptionsFotoList}
                      sx={{ width: "100%" }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ m: 1, mx: 5 }}>
              <Grid item xs={12} md={12} lg={4}>
                <TextField
                  inputProps={{
                    autoComplete: "off"
                  }}
                  id="observaciones"
                  label="Observaciones"
                  variant="outlined"
                  name="observaciones"
                  value={itemCrudLocal.observaciones}
                  onChange={handleChange}
                  multiline
                  rows={3}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      minHeight: '80px',
                      minWidth: '400px',
                    }
                  }}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                />
              </Grid>
            </Box>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", py: 1, pr: 5 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={_action === "disable" ? "error" : "primary"}
                  startIcon={
                    _action === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : _action === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {_action === "disable"
                    ? "Deshabilitar"
                    : _action === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelar}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Box>
        </Paper>
      </Paper >

      {openSolucionLimpiezaMaterialLCDialog && (
        <SolucionLimpiezaMaterialLCDialog
          onSave={handleOnSaveLcMaterial}
          onClose={handleCloseLcMaterialDialog}
          actionCrud={actionCrud}
          itemCrud={itemCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openCodigoExternoDialog && (
        <CodigoExternoDialog
          onSave={handleOnSaveCodigoExterno}
          onClose={handleCloseCodigoExternoDialog}
          actionCrud={actionCrud}
          itemCrud={itemCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openFotoDialog && (
        <FotoDialog
          onSave={handleOnSaveFoto}
          onClose={handleCloseFotoDialog}
          actionCrud={actionCrud}
          arrayFotos={arrayFotos}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default SolucionLimpieza;
